import React, { Component } from 'react';
import { connect } from 'react-redux';
import auth from '@react-native-firebase/auth';
import {
    showError,
    LoadingModal,
    firebaseErrorHandler,
    handleOnCompleteSocialAuth,
    Storage,
    LogoutHelper,
    rehydrateDeepLinkParams,
    setSignupError,
} from 'fitbeat.react-native-components';

class SocialAuthLoadingClass extends Component {
    constructor(props) {
        super(props);
    }

    async componentDidMount() {
        const firstLoad = window.localStorage.getItem('socialAuthFirstLoad');
        if (firstLoad) {
            this.clenaupLocalStorage();
            const providerId = this.props.navigation.getParam('providerId', null);
            const type = this.props.navigation.getParam('type');

            let provider;
            if (providerId === auth.GoogleAuthProvider.PROVIDER_ID) {
                provider = new auth.GoogleAuthProvider();
                provider.setCustomParameters({
                    prompt: 'select_account', // force selecting, https://stackoverflow.com/a/43727675/1016377
                });
            } else if (providerId === 'apple.com') {
                provider = new auth.OAuthProvider('apple.com');
                provider.addScope('email');
                provider.addScope('name');
            } else {
                throw new Error('unknown provider');
            }
            if (type === 'link') {
                auth().currentUser.linkWithRedirect(provider);
                return;
            }
            auth().signInWithRedirect(provider);
        } else {
            auth().getRedirectResult().then(async (result) => {
                var user = result.user;
                if (user) {
                    const userToSend = {
                        additionalUserInfo: result.additionalUserInfo,
                        user: result.user,
                    }
                    const savedBasicUserInfo = JSON.parse(await Storage.get('basicUserInfo', null));
                    const guardianInfo = JSON.parse(await Storage.get('guardianInfo', null));
                    if (guardianInfo) {
                        savedBasicUserInfo.guardianInfo = guardianInfo;
                    }

                    const { navigation, rehydrateDeepLinkParams, setSignupError } = this.props;
                    const type = navigation.getParam('type', 'login');
                    await rehydrateDeepLinkParams();
                    await handleOnCompleteSocialAuth(
                        userToSend, savedBasicUserInfo, navigation.navigate, type, setSignupError);
                } else {
                    this.props.navigation.navigate('Login');
                }
            }).catch((error) => {
                const cleanedError = firebaseErrorHandler(error);
                LogoutHelper();
                showError(cleanedError.message);
                this.props.navigation.navigate('AuthLoading');
            });
        }
    }

    clenaupLocalStorage() {
        window.localStorage.removeItem('socialAuthFirstLoad');
    }

    render() {
        return (
            <div class="social-auth grid-x align-center">
                <LoadingModal isLoading />
            </div>
        )
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        rehydrateDeepLinkParams: () => dispatch(rehydrateDeepLinkParams()),
        setSignupError: (error) => dispatch(setSignupError(error)),
    };
};

SocialAuthLoadingClass = connect(null, mapDispatchToProps)(SocialAuthLoadingClass);
export const SocialAuthLoading = SocialAuthLoadingClass;
